import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';
import { useNavigate } from 'react-router-dom';

import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer, BusinessBenefitsContainer, BusinessBenefitsContent } from './pataPay.styled';

const { VITE_CDN_BASE_URL } = getEnv();

export const PataPay = () => {
  const navigate = useNavigate();

  const handlePataPayLink = () => {
    navigate('/business/pata-pay');
  };

  return (
    <BusinessBenefitsContainer>
      <WidthContainer noBackground>
        <Image
          src={`${VITE_CDN_BASE_URL}/images/image-terminal-with-pata.webp`}
          alt="Pet groomer using the PataPay card reader to pay payments in person"
          height={1500}
          width={2500}
        />
        <BusinessBenefitsContent>
          <h2>
            Flexible payment methods for dog trainers with <span>PataPay</span>
          </h2>
          <p>
            No matter how your clients prefer to pay, Pata makes charging for services easy with online card payments.
          </p>

          <ul>
            <li>Take upfront payments to reduce cancellations and no-shows</li>
            <li>Securely collect clients’ payment cards for any future no-show charges</li>
            <li>Accept in-person payments via Pata card reader with Apple/Google Pay support</li>
            <li>Track your income with Pata booking system with full payment history</li>
            <li>Available with low processing fees per payment and no monthly charges</li>
          </ul>

          <ActionContainer>
            <Button onClick={handlePataPayLink}>Find out more</Button>
          </ActionContainer>
        </BusinessBenefitsContent>
      </WidthContainer>
    </BusinessBenefitsContainer>
  );
};
